<template>
    <form action="#" class="flex w-full md:ml-0" method="GET">

        <div v-if="searchAreaActive" class="fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity"/>
        <label class="sr-only" for="search-field">Search</label>
        <div class="relative w-full text-gray-400 focus-within:text-gray-600 z-10">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center">
                <MagnifyingGlassIcon v-if="!searching" aria-hidden="true" class="h-5 w-5"/>

                <svg
                    v-if="searching" class="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                    <path
                        class="opacity-75" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        fill="currentColor"/>
                </svg>
            </div>
            <input
                id="search-field"
                v-model="query"
                :class="{'bg-transparent': searchAreaActive}"
                :placeholder="placeholder"
                class=" block h-full w-full border-transparent py-2 pl-8 pr-3 text-gray-900 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0 text-sm"
                name="search"
                type="search"
                @focusin="searchAreaActive = true" @input="search">
        </div>


        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
            <div
                v-if="searchAreaActive"
                class=" absolute  px-1 md:pl-0  left-0 top-[3px] w-full lg:left-[260px] lg:w-[calc(100%_-_260px)]">
                <div
                    class="mx-auto w-full  pt-[55px] z-0 transform divide-y divide-gray-100 overflow-hidden rounded-md bg-white  shadow-lg border focus:outline-none transition-all opacity-100 scale-100">
                    <div v-if="showResults" class="max-h-96 scroll-py-3 overflow-y-auto overflow-x-clip p-3">
                        <component
                            :is="result.component" v-for="(result, index) in results" :key="index"
                            :result="result"/>

                        <div v-if="results.length === 0" class="p-3 text-sm">
                            Sorry, we could not find anything under <strong>{{ query }}</strong>.
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </form>
</template>
<script>
import {MagnifyingGlassIcon} from '@heroicons/vue/24/outline/esm/index.js';
import axios from 'axios';
import lodash from 'lodash';
import {Link} from '@inertiajs/vue3';
import InvestorSearchResult from '@/Layouts/Legacy/Partials/InvestorSearchResult.vue';
import DealSearchResult from '@/Layouts/Legacy/Partials/DealSearchResult.vue';

const {debounce} = lodash;


export default {
    components: {
        MagnifyingGlassIcon,
        Link,
        InvestorSearchResult,
        DealSearchResult,
    },
    props: {
        type: {
            type: String,
            default: () => 'investor'
        },

    },
    data() {
        return {
            searchAreaActive: false,
            results: [],
            searching: false,
            query: '',
            showResults: false,
        };
    },

    computed: {
        placeholder() {

            if (this.type === 'investor') {
                return 'Search for Investors';
            }

            if (this.type === 'deal') {
                return 'Search for Startups';
            }

            return 'Search';
        }
    },

    watch: {
        searchAreaActive(val) {
            this.$emit('updateSearchAreaActive', val);
        }
    },

    methods: {
        hideResults() {
            this.showResults = false;
        },
        onSearchFocus() {
            if (this.query.length !== 0 && !this.showResults) {
                this.showResults = true;
            }
        },
        search: debounce(function () {
            if (this.query.length === 0) {
                this.results = [];
                this.showResults = false;
                return;
            }
            this.searching = true;
            axios.get(this.route('api.topbar-search'), {
                params: {
                    query: this.query,
                    type: this.type
                }
            }).then((response) => {
                this.showResults = true;
                this.results = response.data.data;
                this.searching = false;
            }).catch((error) => {
                this.searching = false;
            });
        }, 400)
    }
};
</script>
